import React, { Component } from 'react';
import { connect } from 'react-redux';
import AlertSuccessStudy from '../grammar/AlertSuccessStudy';
import AlertErrorStudy from '../grammar/AlertErrorStudy';
import { Link } from 'react-router-dom';

class ViewAndChoose extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectOption: '',
            optionValue: this.takeOptions(),
            showAlertStudy: '',
            isDisabled: false
        }
    }
    componentDidMount() {
        const optionChoose = document.querySelectorAll('.optionChoose');
        optionChoose.forEach((option) => {
            option.onclick = function () {
                optionChoose.forEach((opt) => opt.classList.remove('optionChooseColor'));
                this.classList.add('optionChooseColor');
            };
        });
    }
    takeOptions = () => {
        if (this.props.study.grammarData !== null) {
            const { grammarData } = this.props.study;
            const correctOptions = this.props.grammar_id;
            const otherOptions = grammarData.map(value => value.grammar_id).filter(grammar_id => grammar_id !== correctOptions);
            const randomOptions = this.shuffle(otherOptions).slice(0, 3);
            const allOptions = this.shuffle([...randomOptions, correctOptions]);
            return allOptions;
        }
    }

    shuffle = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    clickOptionChoose = (option) => {
        this.setState({
            selectOption: option
        });
        const correctOptions = this.props.grammar_id;
        if (correctOptions === option) {
            this.setState({
                showAlertStudy: 'success',
                isDisabled: true
            });
        } else {
            this.setState({
                showAlertStudy: 'error',
                isDisabled: true
            });
        }
    }

    clickCheck = () => {
        const correctOptions = this.props.grammar_id;
        const { selectOption } = this.state;
        if (correctOptions === selectOption) {
            this.setState({
                showAlertStudy: 'success',
                isDisabled: true
            });
        } else {
            this.setState({
                showAlertStudy: 'error',
                isDisabled: true
            });
        }
    }
    howToLearnBackChoose = () => {
        this.props.howToLearnBackChoose();
        this.setState({showAlertStudy: '',isDisabled: false});
    }
    render() {
        // console.log(this.props.grammar_id);
        const { grammarData } = this.props.study;
        const exampleOptionById = (id) => {
            const exampleOption = grammarData.find(value => value.grammar_id === id);
            return exampleOption ? exampleOption.name : '';
        }
        return (
            <div>
                <div className="viewAndChoose">
                    <h2>Hãy xem và chọn đáp án</h2>
                    <div className="view_grammar">{this.props.mean}</div>
                    <div className="optionChooseALL">
                        {
                            Array.isArray(this.state.optionValue) ?
                                (this.state.optionValue.map(value => (
                                    <button key={value} type="button" className="btn btn-primary optionChoose" onClick={() => this.clickOptionChoose(value)} disabled={this.state.isDisabled}>
                                        {exampleOptionById(value)}
                                    </button>
                                )))
                                : (
                                    <Link to='/homeMember'>Vui lòng chọn vào đây để tiến hành ôn tập lại</Link>
                                )
                        }
                    </div>
                    <button name="" id="" className="btn btn-primary check" onClick={this.clickCheck} disabled={this.state.isDisabled}>
                        kiểm tra
                    </button>
                    {this.state.showAlertStudy === 'success' && <AlertSuccessStudy name={this.props.name} mean={this.props.mean} example={this.props.example} mean_example={this.props.mean_example} explain = {this.props.explain} howToLearnNext={this.props.howToLearnNext} />}
                    {this.state.showAlertStudy === 'error' && <AlertErrorStudy name={this.props.name} mean={this.props.mean} example={this.props.example} mean_example={this.props.mean_example} explain = {this.props.explain} howToLearnBack={this.howToLearnBackChoose} nameButton = {'Tiếp tục'}/>}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        study: state.study
    }
}
export default connect(mapStateToProps)(ViewAndChoose);